module.exports = __webpack_public_path__ + "assets/img/Contatti.6629b51b.svg";